module.exports = __webpack_public_path__ + "img/miryoku_t3.40dc1455.png";